// src/crypto/kek.ts
// 用 KEK 包装/解包 root_key。
// 注册：随机 root_key + 包装；解锁：拉 root_key_wrapped + 解包。
import { randomBytes } from "@noble/ciphers/webcrypto";
import { AEAD } from "./params";
import { aeadOpen, aeadSeal, zeroize } from "./aead";
import { buildAAD } from "./aad";
/** 新 root_key（32B 随机）。 */
export function newRootKey() {
    return randomBytes(AEAD.keyLen);
}
export function wrapRootKey(kek, rootKey, userId) {
    const aad = buildAAD({ kind: "rkw", user_id: userId });
    const { bytes } = aeadSeal(kek, rootKey, aad);
    if (bytes.length !== 72) {
        throw new Error(`wrapRootKey: expected 72B, got ${bytes.length}`);
    }
    return { wrapped: bytes };
}
/** 解包 root_key；失败抛错（"密码错误 或 数据损坏"）。 */
export function unwrapRootKey(kek, wrapped, userId) {
    const aad = buildAAD({ kind: "rkw", user_id: userId });
    try {
        return aeadOpen(kek, wrapped, aad);
    }
    finally {
        zeroize(kek); // KEK 用完立即清
    }
}
